// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"84":"c3d22872","153":"bc44021a","609":"f7cdc70e"}[chunkId] + ".chunk.css";
};